import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import {
  AfterViewInit,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  viewChild,
} from '@angular/core';
import Point from '@arcgis/core/geometry/Point.js';
import { MapService } from '../../../../map.service';
import { PowerOutage } from '../../../../models/power-outage.model';
import { AffectedCountPipe } from '../../../../pipes/affected-count.pipe';
import { OutageTypePipe } from '../../../../pipes/outage-type.pipe';
import { DotComponent } from '../../../dot/dot.component';
import { InfoContainerStore } from '../../info-container.store';

@Component({
  selector: 'app-outage-list',
  imports: [CdkMenu, CdkMenuItem, AffectedCountPipe, DotComponent, OutageTypePipe],
  templateUrl: './outage-list.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OutageListComponent implements AfterViewInit {
  private readonly mapService = inject(MapService);
  private readonly infoContainerStore = inject(InfoContainerStore);

  private readonly cdkMenu = viewChild.required(CdkMenu);

  protected readonly outages = computed(
    () => this.infoContainerStore.selectedMunicipality()?.outages ?? [],
  );

  ngAfterViewInit() {
    this.cdkMenu().focusFirstItem();
  }

  protected setSelectedOutage(outageId: number) {
    this.infoContainerStore.setSelectedOutage(outageId);
    this.infoContainerStore.setView('outage');
  }

  protected async zoomToOutage(outage: PowerOutage) {
    const mapView = this.mapService.map()?.nativeElement.view;
    if (!mapView) return;

    const point = new Point({
      x: outage.coordinates.x,
      y: outage.coordinates.y,
      spatialReference: mapView.spatialReference,
    });

    try {
      await mapView.goTo({
        geometry: point,
        zoom: 12,
      });
    } catch (e) {
      console.error('Error while zooming to outage:', e);
    }
  }
}
